/* ELLESANTI V3 · 16/10/2026 sera (Fabio): il menu resta più a lungo quando si scorre in giù.
   v3-ellesanti.js lo nasconde (classe is-hidden sulla sezione) appena si scende di qualche pixel oltre 640 px; qui lo si lascia
   nascondere solo oltre 900 px di pagina e dopo 240 px di discesa continua. Risalendo ricompare subito, come prima. */
(function () {
  var sec = document.querySelector('.e-hd-section');
  if (!sec || !window.MutationObserver) return;
  var H = document.documentElement, lastY = window.scrollY, acc = 0, ok = false;
  function show() { sec.classList.remove('is-hidden'); H.classList.remove('e-hd-hidden'); }
  function check() { if (!ok && sec.classList.contains('is-hidden')) show(); }
  window.addEventListener('scroll', function () {
    var y = window.scrollY, d = y - lastY;
    if (d > 0) acc += d; else if (d < 0) acc = 0;
    lastY = y;
    ok = y > 900 && acc > 240;
    check();
  }, { passive: true });
  new MutationObserver(check).observe(sec, { attributes: true, attributeFilter: ['class'] });
})();

/* Home · gift card essenziale: il bottone apre la scheda con il taglio scelto. */
document.addEventListener('click', function (e) {
  var v = e.target.closest && e.target.closest('[data-e-regc-v]');
  if (!v) return;
  var box = v.closest('[data-e-regc]'), go = box && box.querySelector('[data-e-regc-go]');
  if (!go) return;
  var u = go.getAttribute('href').split('?')[0];
  go.setAttribute('href', u + '?variant=' + v.getAttribute('data-e-regc-v'));
});

/* Home · atelier: la foto compare scorrendo (si apre dal basso, si schiarisce e si assesta da un leggero zoom), legata allo scroll
   con un po' di inerzia. Con il movimento ridotto la foto è subito ferma e visibile. */
(function () {
  if (!document.querySelector('.template-index')) return;
  var w = document.querySelector('.e-lab__img'), img = w && w.querySelector('img');
  if (!w || !img) return;
  try { if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
  w.classList.add('e-rv');
  var cur = -1, raf = 0;
  function frame() {
    raf = 0;
    var r = w.getBoundingClientRect(), vh = window.innerHeight || 800;
    var p = (vh - r.top) / (vh * 0.65);
    p = Math.max(0, Math.min(1, p));
    cur = cur < 0 ? p : cur + (p - cur) * 0.1;
    if (Math.abs(p - cur) < 0.001) cur = p;
    var e = cur * cur * (3 - 2 * cur);
    w.style.setProperty('--rv', e.toFixed(4));
    if (cur !== p) req();
  }
  function req() { if (!raf) raf = requestAnimationFrame(frame); }
  addEventListener('scroll', req, { passive: true });
  addEventListener('resize', req);
  req();
})();

/* Scheda prodotto: miniature dei colori su una riga, che scorre. Trascinamento col mouse; il bordo destro sfuma finché c'è altro. */
(function () {
  document.querySelectorAll('.e-vts').forEach(function (v) {
    function more() { v.classList.toggle('is-more', v.scrollLeft + v.clientWidth < v.scrollWidth - 2); }
    v.addEventListener('scroll', more, { passive: true });
    window.addEventListener('resize', more);
    more();
    var down = false, x0 = 0, s0 = 0, moved = false;
    v.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; x0 = e.clientX; s0 = v.scrollLeft; });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - x0;
      if (!moved && Math.abs(dx) > 5) { moved = true; v.classList.add('is-drag'); }
      if (moved) v.scrollLeft = s0 - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false;
      if (moved) { v.classList.remove('is-drag'); var k = function (ev) { ev.preventDefault(); ev.stopPropagation(); }; v.addEventListener('click', k, true); setTimeout(function () { v.removeEventListener('click', k, true); moved = false; }, 0); }
    });
  });
})();

/* Scheda prodotto, desktop: le foto compaiono scorrendo, con inerzia. Con il movimento ridotto restano ferme. */
(function () {
  var fs = [].slice.call(document.querySelectorAll('.e-gal__g .e-gi'));
  if (!fs.length) return;
  try { if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
  var mq = window.matchMedia ? matchMedia('(min-width: 1024px)') : { matches: true };
  var cur = fs.map(function () { return -1; }), raf = 0;
  fs.forEach(function (f) { f.classList.add('e-gv'); });
  function frame() {
    raf = 0;
    if (!mq.matches) { fs.forEach(function (f) { f.style.removeProperty('--gv'); }); return; }
    var vh = window.innerHeight || 800, again = false;
    fs.forEach(function (f, i) {
      var r = f.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (vh - r.top) / (vh * 0.45)));
      var c = cur[i] < 0 ? p : cur[i] + (p - cur[i]) * 0.12;
      if (Math.abs(p - c) < 0.001) c = p; else again = true;
      cur[i] = c;
      var e = c * c * (3 - 2 * c);
      f.style.setProperty('--gv', e.toFixed(4));
    });
    if (again) req();
  }
  function req() { if (!raf) raf = requestAnimationFrame(frame); }
  addEventListener('scroll', req, { passive: true });
  addEventListener('resize', req);
  req();
})();

/* Scheda prodotto, desktop: «Con te ogni giorno» e «La materia, da vicino» come le «overlapping cards» di Gario.
   Le sezioni V3 · Foto e testo una dopo l'altra diventano un solo blocco: da un lato le foto, ferme a tutto schermo, che scorrendo
   si sovrappongono una sull'altra; dall'altro i testi, ognuno su un pannello calce alto quanto lo schermo, al centro.
   Il lato delle foto lo decide la prima sezione (Foto a sinistra / a destra). Su mobile restano le sezioni normali. */
(function () {
  var mq = window.matchMedia ? matchMedia('(min-width: 1024px)') : { matches: true, addEventListener: function () {} };
  var built = [];
  function groups() {
    var all = [].slice.call(document.querySelectorAll('.shopify-section.e-split-section')).filter(function (s) {
      return s.querySelector('.e-split__im') && s.querySelector('.e-split__t');
    });
    var gs = [], g = [];
    all.forEach(function (s) {
      if (g.length && g[g.length - 1].nextElementSibling !== s) { gs.push(g); g = []; }
      g.push(s);
    });
    if (g.length) gs.push(g);
    return gs;
  }
  function build() {
    groups().forEach(function (g) {
      var first = g[0].querySelector('.e-split'), last = g[g.length - 1].querySelector('.e-split');
      var w = document.createElement('div');
      w.className = 'e-ovl' + (first.classList.contains('e-split--rev') ? ' e-ovl--rev' : '');
      w.style.setProperty('--e-pt', first.style.getPropertyValue('--e-pt') || '0px');
      w.style.setProperty('--e-pb', last.style.getPropertyValue('--e-pb') || '0px');
      var ci = document.createElement('div'); ci.className = 'e-ovl__ims';
      var ct = document.createElement('div'); ct.className = 'e-ovl__txs';
      var rec = { w: w, items: [] };
      g.forEach(function (s, i) {
        var sp = s.querySelector('.e-split'), im = sp.querySelector('.e-split__im'), t = sp.querySelector('.e-split__t');
        var c = document.createElement('div'); c.className = 'e-ovl__c'; c.style.zIndex = i + 1;
        c.style.setProperty('--e-pos', sp.style.getPropertyValue('--e-pos') || '50% 50%');
        c.appendChild(im); ci.appendChild(c);
        var p = document.createElement('div'); p.className = 'e-ovl__p'; p.appendChild(t); ct.appendChild(p);
        s.style.display = 'none';
        rec.items.push({ s: s, sp: sp, im: im, t: t, c: c, p: p });
      });
      w.appendChild(ci); w.appendChild(ct);
      g[0].parentNode.insertBefore(w, g[0]);
      built.push(rec);
    });
    size();
  }
  function undo() {
    built.forEach(function (rec) {
      rec.items.forEach(function (it) { it.sp.appendChild(it.im); it.sp.appendChild(it.t); it.s.style.display = ''; });
      if (rec.w.parentNode) rec.w.parentNode.removeChild(rec.w);
    });
    built = [];
  }
  function size() {
    var vh = window.innerHeight || 800;
    built.forEach(function (rec) {
      rec.items.forEach(function (it) { it.c.style.marginBottom = Math.max(0, it.p.offsetHeight - vh) + 'px'; });
    });
  }
  function sync() { if (mq.matches && !built.length) build(); else if (!mq.matches && built.length) undo(); }
  sync();
  try { mq.addEventListener('change', sync); } catch (e) { if (mq.addListener) mq.addListener(sync); }
  addEventListener('resize', size);
  addEventListener('load', size);
})();

/* Home · il video del metodo (versione al centro) si allarga scorrendo: parte rientrato ai lati (7% della larghezza su desktop,
   16 px su mobile) e arriva a tutta larghezza quando la sezione è salita di due terzi dello schermo, prima che la frase si accenda.
   Con il movimento ridotto resta subito a tutta larghezza. */
(function () {
  var m = document.querySelector('.e-met--centro');
  if (!m) return;
  try { if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
  var cur = -1, raf = 0;
  function frame() {
    raf = 0;
    var vh = window.innerHeight || 800, r = m.getBoundingClientRect();
    var max = window.innerWidth >= 1024 ? Math.round(window.innerWidth * 0.07) : 16;
    var p = Math.max(0, Math.min(1, (vh - r.top) / (vh * 0.65)));
    cur = cur < 0 ? p : cur + (p - cur) * 0.12;
    if (Math.abs(p - cur) < 0.001) cur = p;
    var e = cur * cur * (3 - 2 * cur);
    m.style.setProperty('--mx', ((1 - e) * max).toFixed(1) + 'px');
    if (cur !== p) req();
  }
  function req() { if (!raf) raf = requestAnimationFrame(frame); }
  addEventListener('scroll', req, { passive: true });
  addEventListener('resize', req);
  req();
})();

/* Collezioni · «Prodotto in evidenza»: la composizione compare quando entra nello schermo (prima la card, poi la foto indossata).
   Con il movimento ridotto si vede subito, senza transizioni. */
(function () {
  var vs = document.querySelectorAll('.e-evc');
  if (!vs.length) return;
  try { if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
  if (!window.IntersectionObserver) return;
  vs.forEach(function (v) {
    v.classList.add('e-evm');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { v.classList.add('is-on'); io.disconnect(); } });
    }, { threshold: 0.2 });
    io.observe(v);
  });
})();
